import { render, staticRenderFns } from "./NuevoMensajeTimeline.vue?vue&type=template&id=efe0f088&"
import script from "./NuevoMensajeTimeline.vue?vue&type=script&lang=js&"
export * from "./NuevoMensajeTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports